module.exports = __webpack_public_path__ + "img/video-skin.f90fef3d.jpg";